import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  companyFilters: {
    countries: [],
    minYearsInOperation: '',
    maxYearsInOperation: '',
    sectors: [],
    financingTypes: [],
    minInvestmentAsk: '',
    maxInvestmentAsk: '',
    investmentAskCurrency: 0,
    assetValue:'',
    averageAnnualRevenue: '',
    averageNetProfitMargin: '',
    averageEbitda:'',
    minRiskScore: '',
    maxRiskScore: ''
  },
  advancedFilters: {
    minAnnualRevenue: '',
    maxAnnualRevenue: '',
    minOperatingExpenses: '',
    maxOperatingExpenses: '',
    minNetProfit: '',
    maxNetProfit: '',
    minNetProfitMargin: '',
    maxNetProfitMargin: '',
    minGrossProfit: '',
    maxGrossProfit: '',
    minGrossProfitMargin: '',
    maxGrossProfitMargin: '',
    minEbitda: '',
    maxEbitda: '',
    minEbitdaMargin: '',
    maxEbitdaMargin: '',
    year: 1,
    startingYear: '',
    endingYear: '',
  },
  providerFilters: {
    countries: [],
    minYearsInOperation: '',
    maxYearsInOperation: '',
    sectors: [],
    serviceOfferings:[]
  },
  financierFilters: {
    countries: [],
    startDate: '',
    endDate: '',
    sectors: [],
  },
  grantProviderFilters: {
    areaOfSupport:'',
    totalBudget:'',
    organisationType:'',
    countries:[]
  },
  callFilters: {
    countries: [],
    startDate: '',
    endDate: '',
    sectors: [],
  },
  callOverviewFilters: {
    startDate:'',
    endDate:'',
    stage_id:'',
  },
  showFilters: false,
  // other settings can be added here
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setCompanyFilters(state, action) {
      state.companyFilters = action.payload
    },
    setAdvancedFilters(state, action) {
      state.advancedFilters = action.payload
    },
    setProviderFilters(state, action) {
      state.providerFilters = action.payload
    },
    setFinancierFilters(state, action) {
      state.financierFilters = action.payload
    },
    setGrantProviderFilters(state, action) {
      state.grantProviderFilters = action.payload
    },
    setCallFilters(state, action) {
      state.callFilters = action.payload
    },
    setCallOverviewFilters(state, action) {
      state.callOverviewFilters = action.payload
    },
    toggleFiltersState(state, action) {
      state.showFilters = action.payload
    },
  },
})

export const {
  setAdvancedFilters,
  setCompanyFilters,
  setProviderFilters,
  setFinancierFilters,
  setCallFilters,
  setCallOverviewFilters,
  toggleFiltersState,
  setGrantProviderFilters
} = settingsSlice.actions
export default settingsSlice.reducer
